module.exports = __webpack_public_path__ + "img/2.f8290d35.jpg";